import Icon from '../components/Icon.vue'

Icon.register({
  swatchbook: {
    width: 511,
    height: 512,
    paths: [
      {
        d: 'M479.1 320c17.6 0 31.9 14.3 31.9 32v128c0 17.7-14.3 32-31.9 32h-299.6c2.2-1.9 4.6-3.4 6.7-5.5l186.1-186.5h106.8zM434.6 167.1c12.5 12.5 12.5 32.8 0 45.3l-211.9 212.3c0.2-2.9 0.9-5.7 0.9-8.6v-263.8l75.5-75.7c12.5-12.5 32.7-12.5 45.2 0zM191.6 32v384c0 53-42.9 96-95.8 96-52.9 0-95.8-43-95.8-96v-384c0-17.7 14.3-32 31.9-32h127.7c17.6 0 31.9 14.3 31.9 32zM95.8 440c13.2 0 24-10.8 24-24 0-13.3-10.7-24-24-24-13.2 0-23.9 10.7-23.9 24 0 13.3 10.7 24 23.9 24zM127.8 256l0-64h-63.9v64h63.9zM127.8 128l0-64h-63.9v64h63.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/swatchbook.js
// module id = 1968
// module chunks = 0